module.exports = __webpack_public_path__ + "static/media/ExamSuccess.d6790f1e.svg";